import SchemaFormAutoSubmit from "@/components/Schema/SchemaFormAutoSubmit";
import { PageHeader } from "@ant-design/pro-components";
import { createForm } from "@formily/core";
import { Button, Tabs } from "antd";
import { useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MMNavigationRoutes from "../../utils/navigationRoutes";

const DonationFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const schemaNewCampaign = "MM New Campaign";
  const schemaIndividual = "MM Individual";
  const schemaOrganization = "MM Organization";

  const formNewCampaign = useMemo(() => createForm({}), []);
  const formIndividual = useMemo(() => createForm({}), []);
  const formOrganization = useMemo(() => createForm({}), []);
  const formNewCampaignRef = useRef<{ handleSave: () => Promise<void> }>(null);
  const formIndividualRef = useRef<{ handleSave: () => Promise<void> }>(null);
  const formOrganizationRef = useRef<{ handleSave: () => Promise<void> }>(null);

  return (
    <>
      <PageHeader
        className="custom-page-header"
        title={"Add Donation"}
        onBack={() => navigate("/mm" + MMNavigationRoutes.DONATION_LIST)}
      />
      <Tabs
        items={[
          {
            key: "1",
            label: "New Campaign",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formNewCampaign}
                  schemaName={schemaNewCampaign}
                  recordId={id}
                  ref={formNewCampaignRef}
                />
                <div className="flex gap-4">
                  <Button
                    type="primary"
                    onClick={() => {
                      formNewCampaignRef.current?.handleSave();
                      navigate("/mm" + MMNavigationRoutes.DONATION_LIST);
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
          {
            key: "2",
            label: "Individual",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formIndividual}
                  schemaName={schemaIndividual}
                  recordId={id}
                  ref={formIndividualRef}
                />
                <div className="flex gap-4">
                  <Button
                    type="primary"
                    onClick={() => {
                      formIndividualRef.current?.handleSave();
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
          {
            key: "3",
            label: "Organization",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formOrganization}
                  schemaName={schemaOrganization}
                  recordId={id}
                  ref={formOrganizationRef}
                />
                <div className="flex gap-4">
                  <Button
                    type="primary"
                    onClick={() => {
                      formOrganizationRef.current?.handleSave();
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default DonationFormPage;
